<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/pc_banner_sup_vip.webp`)">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="main-title">
          VIPにアップグレードする方法
        </h1>

        <h2 class="subheading fs_15px">
          【現金ウォレット】ベットにより有効ベット額が発生し、<br>
          VIPアップグレードの計算が自動的に累積され、<br>
          アップグレード条件が満たされると、システムが自動的にアップグレードされます。
        </h2>

        <hr class="hr_line my_5r">

        <h1 class="main-title">
          VIPアップグレードに必要なベット額を確認する
        </h1>

        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item" :class="{'is-btn-active': isActive}" @click="toggleActive">
              PC版
            </li>
            <li class="tab-list-item" :class="{'is-btn-active': !isActive}" @click="toggleActive">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents" :class="{'is-contents-active': isActive}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面のアカウントをプルダウンし「アカウント」をクリック
              </h2>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/vip_pc_tab_01.png`)" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                1. VIPレベル<br>
                2. 有効ベット額の進行状況<br>

                3. 元本累計の有効ベット額<br>

                4. 該当レベルで必要な有効ベット額<br>
              </h2>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/vip_pc_tab_02.png`)" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents" :class="{'is-contents-active': !isActive}">
              <h1 class="main-title">
                ステップ 1
              </h1>
              <h2 class="subheading fs_6">
                ホーム画面の「3本線アイコン」をタップ
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/vip_mb_tab_01.png`)" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h2 class="subheading fs_6">
                アカウントをプルダウンし「アカウント」をタップ
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/vip_mb_tab_02.png`)" alt="">
              </div>

              <h1 class="main-title">
                ステップ 3
              </h1>
              <h2 class="subheading fs_6">
                1. VIPレベル<br>

                2. 有効ベット額の進行状況<br>

                3. 元本累計の有効ベット額<br>

                4. 該当レベルで必要な有効ベット額
              </h2>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/vip_mb_tab_03.png`)" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>
        </div>
        <!-- tab-frame End -->
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
      isActive: true
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    toggleActive() {
      this.isActive = !this.isActive
    }
  }
}
</script>
